import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

export const ModalExpenses = ({useFetchInit}) => {

  const {
    globalStates,
    Actions,
    defaultData,
    Forms
  } = useFetchInit

  const {FormExpenses:{formState, onInputChange, onInputChangeForNumber}} = Forms

  const {modalOpeningMode} = globalStates

  const {handleClickCloseModal, onSubmitFormExpenses} = Actions

  return (
    <form onSubmit={onSubmitFormExpenses}>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth> 
            <label htmlFor="title">* Titulo</label>
            <TextField
                id='title'
                name='title'
                value={ formState.title }
                onChange={ onInputChange }
                size='small'
                placeholder='Titulo'
                hiddenLabel
                type='text'
                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                InputProps={{
                    readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                }}
                required
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth> 
            <label htmlFor="supplier">* Proveedor</label>
            <TextField
                id='supplier'
                name='supplier'
                value={ formState.supplier }
                onChange={ onInputChange }
                size='small'
                placeholder='Proveedor'
                hiddenLabel
                type='text'
                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                InputProps={{
                    readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                }}
                required
            />
          </FormControl>
        </Grid>
      </Grid>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth> 
            <label htmlFor="advance">* Anticipo</label>
            <TextField
                id='advance'
                name='advance'
                value={ formState.advance }
                onChange={ onInputChangeForNumber }
                size='small'
                placeholder='Anticipo'
                hiddenLabel
                type='text'
                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                InputProps={{
                    readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                }}
                required
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth> 
            <label htmlFor="expense">* Total</label>
            <TextField
                id='expense'
                name='expense'
                value={ formState.expense }
                onChange={ onInputChangeForNumber }
                size='small'
                placeholder='Total'
                hiddenLabel
                type='text'
                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                InputProps={{
                    readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                }}
                required
            />
          </FormControl>
        </Grid>

      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <FormControl fullWidth>
            <label htmlFor="description">Descripcion</label>
            <TextField
                id='description'
                name='description'
                value={ formState.description } 
                onChange={onInputChange}
                size='small'
                placeholder='Descripcion'
                type='text'
                multiline
                rows={4}
                variant='outlined'
            />
            <Typography
              variant="caption"
              align="right"
              color={formState.description.length >= 500 ? 'error' : 'textSecondary'}
            >
              {formState.description.length} / 500
            </Typography> 
          </FormControl>
        </Grid>
      </Grid>

      <Grid container justifyContent="center" alignItems="center" style={{ height: '10%' }}>                
        <Grid item xs={12}>
          <div className="text-center">
            <Button 
                startIcon={<ArrowLeftCircle/>}
                variant="contained"
                type="button" 
                className='btn-round'
                color='warning'
                onClick={() => handleClickCloseModal(false, 'EDIT')} 
                sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
            >
                Volver
            </Button>
              
            {(modalOpeningMode==='EDITABLE') && (
                <Button
                    endIcon={<ArrowRightCircle/>}
                    variant="contained"
                    type="submit"
                    className='btn-round'
                    color='primary'
                    sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                >
                    {(formState.idexpense>0) ? 'Actualizar' : 'Guardar'}
                </Button>
            )}
          </div>
        </Grid>
      </Grid>
                
    </form>
  )
}
